import "./App.scss";

import { BannerNotifications } from "@sbb-rsu/ui-banners";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AppProviders } from "AppProviders";
import AppRoutes from "AppRoutes";
import LazyBoardRedirect from "BoardRedirect/LazyBoardRedirect";
import LazyBoards from "Boards/LazyBoards";
import LazyBoardSettings from "BoardSettings/LazyBoardSettings";
import { Footer } from "components/Footer/Footer";
import { Header } from "components/Header/Header";
import { MeetingNav } from "components/MeetingNav/MeetingNav";
import { NotFound } from "components/NotFound/NotFound";
import { ScrollToTop } from "components/ScrollTop";
import LazyDashboard from "Dashboard/LazyDashboard";
import LazyMeeting from "Meeting/LazyMeeting";
import LazyMeetingAgendaItems from "MeetingAgendaItems/LazyMeetingAgendaItems";
import LazyMeetingDocuments from "MeetingDocuments/LazyMeetingDocuments";
import LazyMeetingOneDriveSync from "MeetingOneDriveSync/LazyMeetingOneDriveSync";
import LazyMeetingParticipants from "MeetingParticipants/LazyMeetingParticipants";
import LazyMeetings from "Meetings/LazyMeetings";
import LazyMeetingTasks from "MeetingTasks/LazyMeetingTasks";
import { useTranslations } from "providers";
import React from "react";
import Modal from "react-modal";
import { Route, Routes } from "react-router";
import { ToastContainer } from "react-toastify";

import { RouteLoader } from "./RouteLoader";

Modal.setAppElement("#root");

// Create a client
const queryClient = new QueryClient();

export const App = () => {
  const i18n = useTranslations();

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <AppProviders>
        <Header />

        <ToastContainer hideProgressBar theme="colored" pauseOnFocusLoss={true} position="top-right" />
        <BannerNotifications language={i18n.currentLanguage} className="rsu-banners" />
        <ScrollToTop />

        <main role="main" className="main-content lean-section">
          <div className="container-fluid mb-5">
            <MeetingNav />

            <React.Suspense fallback={<RouteLoader />}>
              <Routes>
                <Route path={AppRoutes.Home} element={<LazyDashboard />} />

                <Route path={AppRoutes.Boards} element={<LazyBoards />} />
                <Route path={AppRoutes.Board} element={<LazyBoardRedirect />} />
                <Route path={AppRoutes.BoardSettings} element={<LazyBoardSettings />} />

                <Route path={AppRoutes.BoardMeetings} element={<LazyMeetings />} />
                <Route path={AppRoutes.BoardMeeting} element={<LazyMeeting />} />
                <Route path={AppRoutes.BoardMeetingAgendaItems} element={<LazyMeetingAgendaItems />} />
                <Route path={AppRoutes.BoardMeetingParticipants} element={<LazyMeetingParticipants />} />
                <Route path={AppRoutes.BoardMeetingTasks} element={<LazyMeetingTasks />} />
                <Route path={AppRoutes.BoardMeetingDocuments} element={<LazyMeetingDocuments />} />
                <Route path={AppRoutes.BoardMeetingOneDriveSync} element={<LazyMeetingOneDriveSync />} />
                <Route path={AppRoutes.NotFound} element={<NotFound />} />
              </Routes>
            </React.Suspense>
          </div>
        </main>
        <Footer />
      </AppProviders>
    </QueryClientProvider>
  );
};
